/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  PageContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    minHeight: '100vh'
  }),

  ContentContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  })),

  MainContent: styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  })),

  PageContent: styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 200px)',
      padding: theme.spacing(3)
    }
  }))
};
